<template>
    <el-container>
      <div class="mailSendCompleted">
        <p class="notes"><i class="el-icon-success"/><span class="p0-p5">{{$t("wm_lang_html_f25118")}}</span><el-button type="primary" size="mini" @click="back">{{$t("wm_lang_html_b79a4e")}} {{$t("wm_lang_html_e0a113")}}</el-button></p>
      </div>
    </el-container>
</template>

<script>
  import AppHeader from '@/components/sub/Header.vue'
  import AppFooter from '@/components/sub/Footer.vue'

  export default {
    name: 'WriteSent',
    data () {
      return {
        msgindex: this.$i18n.t('wm_lang_12da81')
      }
    },
    components:{
      'app-header': AppHeader,
      'app-footer': AppFooter
    },
    computed: {
      //
    },
    mounted() {
      // console.log(this.$route)
    },
    activated() {
      //
    },
    deactivated() {
      //
    },
    methods: {
      back() {
        this.$EventBus.$emit("closeSentPage");
      }
    }
  }
</script>

<style lang="scss">
  .wmCloudsWrapper{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
  }
  $h-row: 28px;
</style>



// WEBPACK FOOTER //
// src/components/views/layout/boxSent.vue